"use client";
import SectionPage from "@/components/common/section-page";

import EspaceProTitleCard from "@/components/common/espace-pro-title-card";
import {PaveScaleCard} from "@/components/common/pave-scale-card";

export default function Home() {

    return (
        <div className={"flex flex-col gap-6 pb-6 mb-8"}>


            <EspaceProTitleCard title={"Réglementation"}
                                middleBreadcrumbs={[
                                    {title: "Pôle de l’Observation et des Etudes", link: "/espace-pro/pole-observation-etudes"},
                                ]}
                                description={"L’approche du tourisme est économique et sous cet angle, le tourisme s’entend des activités des personnes appelées visiteurs."}/>

            {/* Nature & Biodiversité */}
            <SectionPage sectionType="lg">
                <div className={"grid grid-cols-1 md:grid-cols-4 gap-4"}>
                    <PaveScaleCard title={<></>} buttonLabel={"Télécharger"} className={"h-[400px] items-center text-center"}
                                   link="/pdf-viewer/GLOSSAIRE-UNWTO-TOURISME.pdf"
                                   image={"/images/espace-pro/pole-observation-etudes/observatoire-activite-toursistique-monde/1.jpg"}
                                   titleClassName={"font-exo font-bold text-2xl mb-16"}/>

                    <PaveScaleCard title={<></>} buttonLabel={"Télécharger"} className={"h-[400px] items-center text-center"}
                                   link="/pdf-viewer/WEF-Travel-Tourism-Development-2021.pdf"
                                   image={"/images/espace-pro/pole-observation-etudes/observatoire-activite-toursistique-monde/2.jpg"}
                                   titleClassName={"font-exo font-bold text-2xl mb-16"}/>

                    <PaveScaleCard title={<></>} buttonLabel={"Télécharger"} className={"h-[400px] items-center text-center"}
                                   link="/pdf-viewer/Faits-saillants-du-Tourisme-International-.pdf"
                                   image={"/images/espace-pro/pole-observation-etudes/observatoire-activite-toursistique-monde/3.jpg"}
                                   titleClassName={"font-exo font-bold text-2xl mb-16"}/>

                    <PaveScaleCard title={<></>} buttonLabel={"Télécharger"} className={"h-[400px] items-center text-center"}
                                   link="/pdf-viewer/Tourisme-International-2019-Chiffres-Cles-tendances-et-statistiques.pdf"
                                   image={"/images/espace-pro/pole-observation-etudes/observatoire-activite-toursistique-monde/4.jpg"}
                                   titleClassName={"font-exo font-bold text-2xl mb-16"}/>

                    <PaveScaleCard title={<></>} buttonLabel={"Télécharger"} className={"h-[400px] items-center text-center"}
                                   link="/pdf-viewer/Tourisme-International-2020-Chiffres-Cles-tendances-et-statistiques.pdf"
                                   image={"/images/espace-pro/pole-observation-etudes/observatoire-activite-toursistique-monde/5.jpg"}
                                   titleClassName={"font-exo font-bold text-2xl mb-16"}/>

                    <PaveScaleCard title={<></>} buttonLabel={"Télécharger"} className={"h-[400px] items-center text-center"}
                                   link="/pdf-viewer/Tourisme-International-2021-Chiffres-Cles-tendances-et-statistiques.pdf"
                                   image={"/images/espace-pro/pole-observation-etudes/observatoire-activite-toursistique-monde/6.jpg"}
                                   titleClassName={"font-exo font-bold text-2xl mb-16"}/>

                    <PaveScaleCard title={<></>} buttonLabel={"Télécharger"} className={"h-[400px] items-center text-center"}
                                   link="/pdf-viewer/Compendium-UNWTO-2016-2020-ed-2022-copie.pdf"
                                   image={"/images/espace-pro/pole-observation-etudes/observatoire-activite-toursistique-monde/7.jpg"}
                                   titleClassName={"font-exo font-bold text-2xl mb-16"}/>

                    <PaveScaleCard title={<></>} buttonLabel={"Télécharger"} className={"h-[400px] items-center text-center"}
                                   link="/pdf-viewer/Yearbook-UNWTO-2016-2020-ed-2022.pdf"
                                   image={"/images/espace-pro/pole-observation-etudes/observatoire-activite-toursistique-monde/8.jpg"}
                                   titleClassName={"font-exo font-bold text-2xl mb-16"}/>

                    <PaveScaleCard title={<></>} buttonLabel={"Télécharger"} className={"h-[400px] items-center text-center"}
                                   link="/pdf-viewer/Marque-Afrique-Guide-UNWTO-Juil-2022.pdf"
                                   image={"/images/espace-pro/pole-observation-etudes/observatoire-activite-toursistique-monde/9.jpg"}
                                   titleClassName={"font-exo font-bold text-2xl mb-16"}/>

                    <PaveScaleCard title={<></>} buttonLabel={"Télécharger"} className={"h-[400px] items-center text-center"}
                                   link="/pdf-viewer/Tourism-Highlights.pdf"
                                   image={"/images/espace-pro/pole-observation-etudes/observatoire-activite-toursistique-monde/10.jpg"}
                                   titleClassName={"font-exo font-bold text-2xl mb-16"}/>
                </div>
            </SectionPage>

        </div>
    );
}
